import { formatDate } from "src/Utils/DateUtils";
import { User } from "../../PartnerCommunication/BalanceConfirmationBeta/MoveTaskToReconModal";

export enum REPORT_TYPES {
  Status = "status",
  Funnel = "funnel",
}
export interface MISFilters {
  category?: string[];
  relationship?: string;
  taskLabel?: string[];
  approver?: User[];
  period?: Date;
  activityPeriod?: { from: Date; to: Date };
  taskBucket?: string[];
}
export enum REPORT_VIEWS {
  TaskLabel = "Task Label",
  Category = "Category",
  Relationship = "Relationship",
  Company = "Company",
  Branch = "Branch",
  Approver = "Approver",
  ActivityPeriod = "Activity Period",
  Maker = "Maker",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  HalfYearly = "Half Yearly",
  Yearly = "Yearly",
}
export interface ListAllReportResponse {
  categories: string[];
  labels: string[];
  stakeholders: string[];
  users: User[];
  reports: MISReportDetails[];
}
export enum FUNNEL_METRIC_TYPES {
  Volume = "volume",
  Value = "value",
}
export interface MISReportDetails {
  id: number;
  reportType: REPORT_TYPES;
  views: any[];
  filters?: MISFilters;
  hiddenColumns: string[];
  reportData: any[];
  columnsOrder: string[];
  metric?: any[];
  reportName: string;
  mailTemplates?: { id: number; name: string }[];
}

export enum REPORT_FILTERS {
  Category = "Category",
  Relationship = "Relationship",
  TaskLabel = "Task Label",
  Approver = "Approver",
  Stakeholder = "Stakeholder",
  Period = "Period",
  ActivityPeriod = "Activity Period",
  TaskBucket = "Task Bucket",
}

export const ALL_RELATIONSHIPS = ["Vendor", "Customer"];

export const FUNNEL_REPORT_COLUMNS = {
  numberOfPartners: "Total Partners",
  partnersContacted: "Partners Contacted",
  partnersResponded: "Partners Responded",
  partnersConfirmedBalance: "Partner Confirmed Balance",
  partnersSharedLedger: "Partner Shared Ledger",
  partnersNotResponded: "Partners Not Responded",
  reconDone: "Recon Done",
  CBDiff: "CB Difference",
  ownBalance: "Own Balance",
  partnerBalance: "Partner Balance",
  invoiceNotBookedByPartner: "Invoice Not Booked by Partner",
  invoiceNotBookedByOwn: "Invoice Not Booked by Own",
  invoiceMisMatch: "Invoice Mismatch",
  paymentNotBookedByPartner: "Payment Not Booked by Partner",
  paymentNotBookedByOwn: "Payment Not Booked by Own",
  paymentMisMatch: "Payment Mismatch",
  dncnNotBookedByPartner: "DN/CN Not Booked by Partner",
  dncnNotBookedByOwn: "DN/CN Not Booked by Own",
  dncnMisMatch: "DN/CN Mismatch",
  tdsNotBookedByPartner: "TDS Not Booked by Partner",
  tdsNotBookedByOwn: "TDS Not Booked by Own",
  invoiceReconciled: "Invoice Reconciled",
  paymentReconciled: "Payment Reconciled",
};

export const STATUS_REPORT_COLUMNS = {
  numberOfPartners: "Number Of Partners",
  actionOwner: "Action Owner",
  ownCB: "Own Closing Balance",
  CBDiff: "Closing Balance Difference",
  averageAging: "Average Aging (In Days)",
  serviceStatus: "Status(Service)",
  status: "Status",
};

export const VIEW_COLUMNS = [
  "relationship",
  "category",
  "taskLabel",
  "approver",
  "activityPeriod",
  "metric",
  "branch",
  "company",
  "maker",
];
export const FUNNEL_REPORT_ALL_COLUMNS = [
  "numberOfPartners",
  "partnersContacted",
  "partnersResponded",
  "partnersConfirmedBalance",
  "partnersSharedLedger",
  "partnersNotResponded",
  "reconDone",
  "CBDiff",
  "ownBalance",
  "partnerBalance",
  "invoiceNotBookedByPartner",
  "invoiceNotBookedByOwn",
  "invoiceMisMatch",
  "paymentNotBookedByPartner",
  "paymentNotBookedByOwn",
  "paymentMisMatch",
  "dncnNotBookedByPartner",
  "dncnNotBookedByOwn",
  "dncnMisMatch",
  "tdsNotBookedByPartner",
  "tdsNotBookedByOwn",
];

export const STATUS_REPORT_ALL_COLUMNS_SERVICE_ACCOUNTS = [
  "status",
  "serviceStatus",
  "numberOfPartners",
  "actionOwner",
  "ownCB",
  "CBDiff",
  "averageAging",
];

export const STATUS_REPORT_ALL_COLUMNS = ["numberOfPartners", "actionOwner", "ownCB", "CBDiff", "averageAging"];

export const REPORT_VIEWS_MAPPING = {
  taskLabel: "Task Label",
  category: "Category",
  branch: "Branch",
  company: "Company",
  approver: "Approver",
  relationship: "Relationship",
  monthly: "Monthly",
  quarterly: "Quarterly",
  halfYearly: "Half Yearly",
  yearly: "Yearly",
  activityPeriod: "Activity Period",
  maker: "Maker",
};

export const MIS_FILTERS_MAPPING = {
  relationship: "Relationship",
  categories: "Categories",
  taskLabel: "Task Label",
  approver: "Approver",
  taskBucket: "Task Bucket",
  period: "Period",
  activityPeriod: "Activity Period",
};

export enum statusTypes {
  serviceStatus = "serviceStatus",
  status = "status",
}

export const renderValueForMISFilters = (key: string, value: any) => {
  if (key === "approver") {
    return value.map((user) => user.name).join(", ");
  }
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "string") return value;
  if (key === "period") return formatDate(value);
  if (key === "activityPeriod") return `${formatDate(value.from)} - ${formatDate(value.to)}`;
};

export const TASK_BUCKET_OPTIONS = ["In Progress", "Saved", "Cleared"];

export const createHiddenColumnsObject = (visibleColumns: string[], reportType: string) => {
  let allColumns = [];
  if (reportType === REPORT_TYPES.Funnel) {
    allColumns = [...FUNNEL_REPORT_ALL_COLUMNS, ...VIEW_COLUMNS];
  }
  if (reportType === REPORT_TYPES.Status) {
    allColumns = [...STATUS_REPORT_ALL_COLUMNS_SERVICE_ACCOUNTS, ...VIEW_COLUMNS];
  }

  return allColumns
    .filter((item) => !visibleColumns.includes(item))
    .reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
};
